<script>

</script>

<div class="warning">
  <span class="fa fa-triangle-exclamation"></span>
  <h2>Warning!</h2>
  <p>TSPquantum detected you are using a mobile device.</p>
  <p>The course platform is not (yet) compatible with mobile browsers. If you want to learn about and have some fun with quantum computers, please do it so on a desktop computer!</p>
  <p>Stay tuned for updates!</p>
</div>

<style>
  .warning {
    text-align: center;
  }
  .warning h2 {
    color: #fa053c
  }
  .warning p {
    color: #fa053c
  }
  .fa-triangle-exclamation {
    color: #fa053c;
    font-size: 50px;
  }
</style>